
import { Component, Vue } from "vue-property-decorator";
import { Route, RawLocation } from "vue-router";
import { API_ROUTES } from "@/utils/API";
import { API_THistory, convertHistoryForTable, THistory_Table } from "@/models/data_history";

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  components: {
    Loader: () => import("@/components/Loader/Loader.vue"),
    ExpertDataHistory: () => import("@/components/DataHistory/ExpertDataHistory.vue"),
  },
})
export default class DataHistory extends Vue {
  loading = false;

  historyItems: THistory_Table[] = [];

  get caseId(): number {
    return Number(this.$route.params.id || 0);
  }

  async fetchHistory(): Promise<void> {
    try {
      this.loading = true;

      const { data } = await this.axios.get<API_THistory[]>(
        API_ROUTES.CASE_PROFILE_HISTORICAL(this.caseId)
      );

      if (!data) return;

      this.historyItems = convertHistoryForTable(data);
    } finally {
      this.loading = false;
    }
  }

  beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: RawLocation | ((vm: Vue) => void)) => void
  ): void {
    next((vm: any) => {
      vm.fetchHistory();
    });
  }
}
